import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.scss'],
  standalone: false,
})
export class NavHeaderComponent {
  auth = inject(AuthService);
  locales = inject(LocaleService);

  appName = 'Product Browser';
  @Output() toggleDrawer = new EventEmitter();
  @Input() forbidden: boolean | undefined;

  getLocaleUrl(): string {
    return `${this.locales
      .getCurrentLocale()
      .language.toLowerCase()}/${this.locales
      .getCurrentLocale()
      .country.toLowerCase()}`;
  }

  clickToggleDrawer() {
    this.toggleDrawer.emit();
  }

  protected readonly environment = environment;
}
